var React = require('react');

function ContactFlag3 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m-132.293343 457.80608 728.929336-420.5302931 171.214409 67.4644581-827.659908 478.441756z","fill":"#4eb684","fillRule":"evenodd","opacity":".05","transform":"matrix(-.8660254 .5 .5 .8660254 613.311303 -330.326474)"}));
}

ContactFlag3.defaultProps = {"height":"145","viewBox":"0 0 811 145","width":"811"};

module.exports = ContactFlag3;

ContactFlag3.default = ContactFlag3;
